import React, { Component } from "react";
import { connect } from "react-redux";
import { ItemSelectedForEditRefund } from "../../../../store/action/index";
import classes from "./RefundHistoryTable.css";
import arrow from "../../../../assets/arrowDown.png";

class RefundHistoryTable extends Component {
  state = {
    DetailsToggle: false,
    key: null
  };

  onDetailsBtn = key => {
    if (key === "all") {
      this.setState(prevState => {
        return {
          DetailsToggle: !prevState.DetailsToggle,
          key: key
        };
      });
    } else
      this.state.key === key
        ? this.setState(prevState => {
            return {
              DetailsToggle: !prevState.DetailsToggle
            };
          })
        : this.setState({
            DetailsToggle: true,
            key: key
          });
  };

  render() {
    return (
      <div className={classes.tBody}>
        <div className={classes.CaptionTable}>
          <p className={classes.ResP}>جزئیات</p>
          <p>شناسه</p>
          <p>تاریخ و ساعت</p>
          <p>نام صاحب حساب</p>
          <p>نام سرگروه مسافر</p>
          <p>وضعیت</p>
          <p>PNR</p>
          <p>شماره بلیط</p>
          <p>ویرایش</p>
          <p
            onClick={() => this.onDetailsBtn("all")}
            className={classes.Just480}
            style={{ cursor: "pointer" }}
          >
            جزئیات
            <img
              style={{ marginRight: "20px" }}
              className={this.state.DetailsToggle ? classes.GerKhordan : null}
              src={arrow}
              alt="توضیحات بیشتر"
            />
          </p>
          {this.state.DetailsToggle ? (
            <div className={classes.Just480}>
              <p>شماره کارت :</p>
              <p>شماره شبا :</p>
              <p>شماره حساب :</p>
              <p>نام بانک : </p>
              <p>دلیل استرداد :</p>
            </div>
          ) : null}
        </div>
        {this.props.refundList ? (
          this.props.refundList.Data.length === 0 ? (
            <div className={classes.eachItem}>
              <p>نتیجه ای یافت نشد ...</p>
            </div>
          ) : (
            this.props.refundList.Data.map(item => {
              return (
                <div className={classes.eachItem} key={item.Id}>
                  <img
                    onClick={() => this.onDetailsBtn(item.Id)}
                    className={[
                      classes.details,
                      this.state.key === item.Id
                        ? this.state.DetailsToggle
                          ? classes.GerKhordan
                          : null
                        : null
                    ].join(" ")}
                    src={arrow}
                    alt="توضیحات بیشتر"
                  />
                  <p>{item.Id}</p>
                  <p>
                    {item.RegDate.slice(11, 16)} {item.P_RegDate}
                  </p>
                  <p>{item.FullName}</p>
                  <p>{item.PassengersHeaderFullName}</p>
                  <p>{item.StatusString}</p>
                  <p>{item.PNR}</p>
                  <p>{item.Watcher}</p>
                  <p>
                    <button
                      className={classes.ChoiseOne}
                      disabled={item.Status !== 1 ? true : false}
                      onClick={() => this.props.ItemSelectedForEditRefund(item)}
                    >
                      <a href="#FormPart">انتخاب</a>
                    </button>
                  </p>
                  {this.state.DetailsToggle &&
                  (this.state.key === item.Id || this.state.key === "all") ? (
                    <div
                      className={[
                        classes.exteraInfo,
                        this.state.DetailsToggle
                          ? classes.ToggleAnimation
                          : null
                      ].join(" ")}
                    >
                      <p>
                        <span>شماره کارت : </span>
                        {item.CardNumber}
                      </p>
                      <p>
                        <span>شماره شبا : </span>
                        {item.IBAN}
                      </p>
                      <p>
                        <span>شماره حساب : </span>
                        {item.AccountNumber}
                      </p>
                      <p>
                        <span>نام بانک : </span>
                        {item.BankName}
                      </p>
                      <p>
                        <span>دلیل استرداد : </span>
                        {item.RefoundReason}
                      </p>
                    </div>
                  ) : null}
                </div>
              );
            })
          )
        ) : (
          <div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
            <div className={classes.eachItemfakeContent}>
              <p className={classes.fakeContent} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    refundList: state.REFUND.refundList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ItemSelectedForEditRefund: item => dispatch(ItemSelectedForEditRefund(item))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RefundHistoryTable);
